import { useEffect } from 'react';

const BRAND = 'ShotBook';

/**
 * Заголовок вкладки: «Страница · ShotBook», без части — просто бренд.
 * Единственное место, где меняется document.title.
 */
export function useDocumentTitle(part: string | null | undefined): void {
  useEffect(() => {
    const previous = document.title;
    document.title = part && part.trim() ? `${part.trim()} · ${BRAND}` : BRAND;
    return () => {
      document.title = previous;
    };
  }, [part]);
}
